import { render, staticRenderFns } from "./StarsSet.vue?vue&type=template&id=13479137&scoped=true"
import script from "./StarsSet.vue?vue&type=script&lang=js"
export * from "./StarsSet.vue?vue&type=script&lang=js"
import style0 from "./StarsSet.scss?vue&type=style&index=0&id=13479137&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13479137",
  null
  
)

export default component.exports